export default __webpack_public_path__ + "static/media/thumbnail.ce52ef7a.webp";